<script setup>
import axios from "axios";
import {useQuery} from "@tanstack/vue-query";
import ActionRow from "@/components/actions/partials/ActionRow.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import GroupedActionPanel from "@/components/actions/partials/GroupedActionPanel.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";

const {data: actions, isLoading} = useQuery({
  queryKey: ['hidden-actions'],
  queryFn: async () => {
    const response = await axios.get('/ajax/v2/actions/hidden');

    return response.data.data;
  },
});
</script>

<template>
  <LoadingBlock v-if="isLoading" />

  <ZeroContent v-else-if="!actions.length">
    Looks like there are no hidden actions to display.
  </ZeroContent>

  <GroupedActionPanel v-else>
    <template #actions>
      <ActionRow
        v-for="action in actions"
        :key="action.id"
        :action="action"
        is-hidden
      />
    </template>
  </GroupedActionPanel>
</template>
